import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isExternalLink } from '../../shared/utility.js';
import classes from './CallToAction.module.scss';
import { IconExternalLink } from '@tabler/icons-react';
import { renderMarkdownToReact } from '../UI/MarkdownText/MarkdownText.js';

const callToAction = (props) => {
    let ctaLink = null;
    const copy = props.copy || null;

    // Todo: Refactor buttonText Prop to linkText because text links for external sites have been added
    if (props.buttonVisibility && props.linkUrl && props.buttonText) {
        if (isExternalLink(props.linkUrl)) {
            ctaLink = (
                <Button
                    outline={props.outline}
                    className={`mt-auto btn-block btn-md-inline-block ${props.btnClass}`}
                    color={props.buttonColor || 'secondary'}
                    style={{ ...props.buttonStyle, ...props.style }}
                    href={props.linkUrl + '/'}
                    target="_blank"
                    rel="external noopener"
                >
                    {props.buttonText}
                    <IconExternalLink size={24} className="ms-1" />
                </Button>
            );
        } else {
            ctaLink = (
                <Button
                    outline={props.outline}
                    className={`mt-auto btn-block btn-md-inline-block ${props.btnClass}`}
                    color={props.buttonColor || 'secondary'}
                    style={{ ...props.buttonStyle, ...props.style }}
                    tag={Link}
                    to={props.linkUrl + '/'}
                >
                    {props.buttonText}
                </Button>
            );
        }
    }

    return (
        <>
            <h2 className={props.bootstrapClass} style={props.headlineStyle}>
                {props.headline}
            </h2>
            {copy && (
                <p className={[classes.CallToAction, props.bootstrapClass].join(' ')} style={props.copyStyle}>
                    {renderMarkdownToReact(copy)}
                </p>
            )}
            {ctaLink}
        </>
    );
};

export default callToAction;
